export default {
    planTemplates: {
        list: [],
        availablePlanGenerationTemplates: [],
        create: { planTemplate: {}, imageReferences: [] }
    }
};
